import { Component } from '@angular/core';

@Component({
  selector: 'app-pdpa',
  templateUrl: './pdpa.component.html',
  styleUrls: ['../pdpa-policy/pdpa-policy.component.css'],
})
export class PdpaComponent {
}
